import React, { Component, PropTypes } from 'react';

import PubSub from 'pubsub-js';

import './Lane.css';
import Artboard from '../components/Artboard';
import { myoService } from '../services/MyoService';
import { storageService } from '../services/StorageService'; 
import utils from '../utils';

class Lane extends Component {
  constructor(props) {
    super(props);

    let { device } = props;
    let settings = 
      storageService.get(storageService.stores.pattern, device.macAddress);

    this.state = {
      settings: settings,
      data: []
    };

    // private variables
    this._counter = 0;
    this._boundaries = {};

    this._handleEmg = this._handleEmg.bind(this);
    this._handleLaneRedraw = this._handleLaneRedraw.bind(this);
  }

  componentDidMount() {
    PubSub.subscribe(myoService.topics.emg, this._handleEmg);
  }

  componentWillUnmount() {
    PubSub.unsubscribe(myoService.topics.emg, this._handleEmg);
    this.props.device.streamEMG(false);
  }

  render() {
    let { device } = this.props;
    let { data, settings } = this.state;
    let style = {
      maxWidth: 400
    };

    return (
      <div className="lane flex-fill flex-column" style={style}>
        <div className="heading">
          <h2>{ device.name }</h2>
        </div>
        <Artboard data={data} settings={settings} onRedraw={this._handleLaneRedraw} />
      </div>
    );
  }

  _handleEmg(topic, bundle) {
    if (bundle.myo.macAddress !== this.props.device.macAddress)
      return;

    let { data, maxIndex } = this.state;
    let scales = utils.translateEmg(bundle.emg);
    scales.id = this._counter++;

    let croppedData = data.slice();
    croppedData.push(scales);
    if (croppedData.length > this._boundaries.maxIndex) {
      // compromise
      croppedData = [];
    }

    this.setState({
      data: croppedData
    });
  }

  _handleLaneRedraw(boundaries) {
    this._boundaries = boundaries;
  }
}

Lane.propTypes = {
  device: PropTypes.object.isRequired
}

export default Lane;


/** WEBPACK FOOTER **
 ** ./src/components/Lane.js
 **/